import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

// Tailwind CSS
import '@/assets/css/tailwind.css'  // Make sure this path points to your Tailwind CSS file

// Existing imports
require('./mixin');
require('@fortawesome/fontawesome-free/css/all.css')
import 'cleave.js'

import Chart from 'chart.js'
Chart.defaults.global.defaultFontFamily = 'IRANSans';

// Global Components
import MDatatable from "@/components/m-datatable";
Vue.component('MDatatable', MDatatable);

import { MForm } from "@/components/m-form";
Vue.component('MForm', MForm);

// Select Components
const selectComponents = {
  WareSelect: () => import('@/components/selects/WareSelect.vue'),
  AccountSelect: () => import('@/components/selects/AccountSelect.vue'),
  CitySelect: () => import('@/components/selects/CitySelect.vue')
};

Object.entries(selectComponents).forEach(([name, component]) => {
  Vue.component(name, component);
});

// Form Components
const formComponents = {
  'money': () => import("@/components/mcomponents/cleave/Money"),
  'date': () => import("@/components/mcomponents/cleave/Date"),
  'mtime': () => import("@/components/mcomponents/cleave/Time"),
  'ContextMenu': () => import("@/components/mcomponents/ContextMenu"),
  'MPhoneField': () => import("@/components/fields/PhoneField"),
  'MNationalCode': () => import("@/components/fields/NationalCode")
};

Object.entries(formComponents).forEach(([name, component]) => {
  Vue.component(name, component);
});

// UI Components
const uiComponents = {
  'OpenSanadBtn': () => import("@/components/btns/OpenSanadBtn"),
  'DetailLink': () => import("@/components/list/DetailLink")
};

Object.entries(uiComponents).forEach(([name, component]) => {
  Vue.component(name, component);
});

// Libraries
import _ from 'lodash'
window._ = _

import $ from 'jquery'
window.$ = $;

// Plugins
import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import vuetify from './plugins/vuetify';

// Fonts
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

// Persian Date Picker
Vue.component('date-picker', VuePersianDatetimePicker);

// Event Bus
export const EventBus = new Vue();

// Vuetify and Tailwind compatibility fix
Vue.config.productionTip = false

// Load Vazirmatn font dynamically
const loadFont = () => {
  const link = document.createElement('link');
  link.href = 'https://fonts.googleapis.com/css2?family=Vazirmatn:wght@400;500;700&display=swap';
  link.rel = 'stylesheet';
  document.head.appendChild(link);
};

loadFont();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  mounted() {
    // Add direction attribute for RTL support
    document.documentElement.setAttribute('dir', 'rtl');
    document.documentElement.setAttribute('lang', 'fa');
  }
}).$mount('#app');